module.exports = __webpack_public_path__ + "img/example2.b6435df4.jpg";